import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-52",
  "use": "icon-sheet_icon-52-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-52\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M12 1.866l8.776 5.067v10.134L12 22.134l-8.776-5.067V6.933L12 1.866z\" /><path stroke-linejoin=\"round\" d=\"M13.956 3.007L8.446 12.9l4.742 2.78-3.31 5.43\" /><path stroke-linejoin=\"round\" d=\"M13.188 15.679l2.586-4.578-4.572-2.619\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol